import React from 'react';
import { inject } from 'mobx-react';
import { EDITOR_GROUPS_STORE } from 'store';
import { observer } from 'mobx-react-lite';
import FrameInfoView from '../FrameInfoView';
import { GroupViewProps } from './types';

const GroupView = (props: GroupViewProps) => {
  const {
    previewFrame,
    name,
    shotIds,
    [EDITOR_GROUPS_STORE]: {
      switchGroupSelection,
      isGroupSelected
    },
    isSelected = isGroupSelected(name),
    isSelectable = true,
    onClick = isSelectable ? () => switchGroupSelection(name) : null
  } = props;

  return (
    <FrameInfoView
      previewFrame={previewFrame}
      name={name}
      shotsCount={shotIds.length}
      isSelectable={isSelectable}
      isSelected={isSelected}
      onClick={onClick}
    />
  );
};

export default inject(EDITOR_GROUPS_STORE)(observer(GroupView));
